var selectedColor;
var selectedGrade;
var EleHeight;
var itemCount;
class americanSwatch {
  constructor(){
    const radioButtonsColor = document.querySelectorAll('[data_color]');
    const radioButtonsGrade = document.querySelectorAll('[data_grade]');
    const gridItems = document.querySelectorAll('[data-swatch-item]');
    itemCount = document.querySelectorAll('[data-swatch-item]').length;

  if(document.querySelectorAll("[data-swatch-item]")[1].querySelector(".swatch-more-wrapper")){

    EleHeight = document.querySelectorAll("[data-swatch-item]")[1].querySelector(".swatch-more-wrapper").offsetHeight;

    document.querySelectorAll("[data-swatch-item]")[0].querySelector("[swatch_detials]").style.height = `${EleHeight}px`

    console.log("EleHeight",EleHeight)
  }

    radioButtonsColor.forEach(ele=>{
        ele.addEventListener("change",(event)=>{
            this._colorChange(event);
        })
    });

   

    radioButtonsGrade.forEach(ele=>{
        ele.addEventListener("change",(event)=>{
            this._gradeChange(event);
        })
    });
    gridItems.forEach(ele=>{
        ele.addEventListener("click",(event)=>{
            this._showItemDetials(event);
        })
    });
    
  }

  _colorChange(event){
     if (event.target.checked) {
       selectedColor = event.target.value;
       this._loadSwatchGrid();
      }
  }

   

   _gradeChange(event){
     if (event.target.checked) {
       selectedGrade = event.target.value;
       this._loadSwatchGrid();
      }
   }
  
  _loadSwatchGrid(){
  const gridElements = document.querySelectorAll('[data-swatch-details]');
    let count = 0;
  gridElements.forEach(ele=>{
    var scriptContent = ele.textContent;
    var data = JSON.parse(scriptContent);
    data.forEach(function(item) {
       let itemFound = false;


         if(selectedColor && selectedGrade){
           if (item.color && item.color.includes(`${selectedColor}`) &&
              item.grade == selectedGrade ) {
              itemFound = true;
             }
         }
         else if(selectedColor && !selectedGrade){
            if (item.color && item.color.includes(`${selectedColor}`) ){
              itemFound = true;
             }
         }
         else if(selectedColor && !selectedGrade){
            if (item.color && item.color.includes(`${selectedColor}`) &&
              item.grade == selectedGrade ) {
              itemFound = true;
            }
         }else if(!selectedColor && selectedGrade){
           if (  
              item.grade == selectedGrade ) {
              itemFound = true;
          }
         }else if(!selectedColor && !selectedGrade){
           if ( item.grade == selectedGrade ) {
              itemFound = true;
          }
         }else if(selectedColor && !!selectedGrade){
           if (item.color && item.color.includes(`${selectedColor}`)){
             itemFound = true;
           }
         } 
      
      if(itemFound == false){
         ele.closest("[data-swatch-item]").classList.add("d-none");
        count = count + 1;
        
      }else{
         ele.closest("[data-swatch-item]").classList.remove("d-none");
      }
    });
    
  
  });
    if(count == itemCount ){
      document.querySelector("[empty-search]").classList.remove("d-none");
    }else{
      document.querySelector("[empty-search]").classList.add("d-none");
    }
  }

  _showItemDetials(event){
    let currentEle = event.currentTarget;
    
    document.querySelectorAll('[data-swatch-item]').forEach(ele=>{
      ele.classList.remove("active");
      ele.querySelector(".image_wrapper").classList.remove("active");
     ele.querySelector("[swatch_detials]").removeAttribute('style')
    });
    
    currentEle.classList.add("active");
    currentEle.querySelector(".image_wrapper").classList.add("active");
    console.log('currentEle',currentEle)
    if(currentEle.querySelector('.swatch-more-wrapper')){
      var height_el = currentEle.querySelector('.swatch-more-wrapper').offsetHeight
      currentEle.querySelector("[swatch_detials]").style.height = `${height_el}px`
    }
          // currentEle.querySelector("[swatch_detials]").style.height = `${EleHeight}px`
    
  }

}
new americanSwatch()